import { gql } from 'apollo-angular'

import { USER_LIST_FIELDS } from '../../fragments/user.fragment'

export const SEAT_ALLOCATION_BY_SUBSCRIPTION = gql`
  query SeatAllocationsBySubscription(
    $subscriptionId: JSON!
    $page: Int!
    $itemsPerPage: Int!
  ) {
    SeatAllocations(
      select: true
      page: $page
      limit: $itemsPerPage
      where: { subscription: { equals: $subscriptionId } }
    ) {
      docs {
        id
        user {
          ...UserListFields
        }
        subscription {
          product {
            id
            name
            magazine {
              id
              title
              media {
                cover {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
  ${USER_LIST_FIELDS}
`
